import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import '../assets/assistantComponents.scss';

const AiAssistantComposer = forwardRef(({
  draft,
  taskLabel,
  contextLabel,
  placeholder,
  busy = false,
  disabled = false,
  onDraftChange,
  onSubmit,
}, ref) => {
  const submit = (event) => {
    event?.preventDefault();
    if (busy || disabled || !draft.trim()) return;
    onSubmit(draft);
  };

  return (
    <form className="ai-assistant-composer" onSubmit={submit}>
      <div className="ai-assistant-composer-task">
        <span>Current task</span>
        <strong>{taskLabel}</strong>
        {contextLabel ? <small>{contextLabel}</small> : null}
      </div>
      <label className="visually-hidden" htmlFor="ai-assistant-prompt">
        Message AI Assistant
      </label>
      <textarea
        id="ai-assistant-prompt"
        ref={ref}
        className="form-control"
        rows="3"
        value={draft}
        onChange={(event) => onDraftChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            submit();
          }
        }}
        placeholder={placeholder}
        disabled={busy || disabled}
      />
      <button
        className="btn btn-primary ai-assistant-send"
        type="submit"
        aria-label="Send message"
        title="Send message"
        disabled={busy || disabled || !draft.trim()}
      >
        {busy ? (
          <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
        ) : (
          <i className="bi bi-arrow-up" aria-hidden="true"></i>
        )}
      </button>
      <p className="ai-assistant-disclaimer">
        AI can make mistakes. Check important information.
      </p>
    </form>
  );
});

AiAssistantComposer.displayName = 'AiAssistantComposer';

AiAssistantComposer.propTypes = {
  draft: PropTypes.string.isRequired,
  taskLabel: PropTypes.string.isRequired,
  contextLabel: PropTypes.string,
  placeholder: PropTypes.string,
  busy: PropTypes.bool,
  disabled: PropTypes.bool,
  onDraftChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AiAssistantComposer;
